import { AbstractControl, ValidatorFn } from '@angular/forms'


export function emailValidator(oppositeCtrl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const confirmEmailval: string = control.value;
        const emailVal: string = oppositeCtrl.value;

        if (emailVal !== null) {
            if (confirmEmailval !== null) {
                if (confirmEmailval.toLowerCase() === emailVal.toLowerCase()) {
                    return null;
                }    
            }
            return {invalidCompareEmail: true}
        }
        return null;
    }
}

export function multipleEmailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        // not required
        if (control.value === null || control.value === '') {
            return null;
        }

        let allValid = false;

        const list = control.value.split(',');
        list.forEach(
            (element:string) => {
                element = element.trim();
                if (element !== '') {
                    allValid = isValidEmailAddress(element) !== null;
                }
            }
        );

        return allValid ? null : { 'invalidEmailList': true };
    }
}

export function isValidEmailAddress(emailAddress: string) {
    // tslint:disable-next-line: max-line-length
    return emailAddress.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}

